(function () {

  var productCache = {};

  function money(cents) {
    if (!cents && cents !== 0) return '';
    var d = Math.floor(cents / 100);
    var c = cents % 100;
    return '$' + d + '.' + (c < 10 ? '0' + c : '' + c);
  }

  function fetchProduct(handle, cb) {
    var hit = productCache[handle];
    if (hit) { cb(hit); return; }
    fetch('/products/' + handle + '.js')
      .then(function (r) { return r.json(); })
      .then(function (d) { productCache[handle] = d; cb(d); })
      .catch(function () { cb(null); });
  }

  function findVariantById(data, variantId) {
    if (!data || !data.variants) return null;
    var id = String(variantId);
    for (var i = 0; i < data.variants.length; i++) {
      if (String(data.variants[i].id) === id) return data.variants[i];
    }
    return null;
  }

  var FR_MAP = {
    'new': 'Nouveau', 'nouveau': 'Nouveau',
    'sale': 'Solde', 'solde': 'Solde',
    'bestseller': 'Meilleur vendeur', 'exclusive': 'Exclusif'
  };

  function applyCardBadge(card, rawBadge) {
    var el = card.querySelector('.card-variant-badge');
    if (!el) return;
    var lang = (document.documentElement.lang || 'en').toLowerCase();
    var label = rawBadge
      ? (lang.startsWith('fr') ? (FR_MAP[rawBadge.toLowerCase()] || rawBadge) : rawBadge)
      : '';
    if (label) {
      el.textContent = label;
      el.classList.add('is-visible');
    } else {
      el.textContent = '';
      el.classList.remove('is-visible');
    }
  }

  function getBadgeForCheckedSwatch(card, badgeMap) {
    var checked = card.querySelector(
      '.product-card__swatch-list input:checked, .product-card__variant-list input:checked'
    );
    if (checked && checked.dataset.variantId) {
      var vid = checked.dataset.variantId;
      if (Object.prototype.hasOwnProperty.call(badgeMap, vid)) return badgeMap[vid];
    }
    // Fallback : premier variant avec badge
    for (var key in badgeMap) {
      if (Object.prototype.hasOwnProperty.call(badgeMap, key) && badgeMap[key]) return badgeMap[key];
    }
    return '';
  }

  // ─── Synchro anneau swatch → image affichée ──────────────────────────────

  function syncSwatchRingToImage(card) {
    var img = card.querySelector('.product-card__image--primary');
    if (!img) return;
    var currentFile = img.src.split('?')[0].split('/').pop();

    var inputs = card.querySelectorAll('input[type="radio"][data-variant-id]');
    var matchingInput = null;

    for (var i = 0; i < inputs.length; i++) {
      var mediaRaw = inputs[i].dataset.variantMedia;
      if (!mediaRaw) continue;
      try {
        var media = JSON.parse(mediaRaw);
        var mediaFile = ((media.preview_image || media).src || '').split('?')[0].split('/').pop();
        if (mediaFile === currentFile) {
          matchingInput = inputs[i];
          break;
        }
      } catch (e) {}
    }

    if (!matchingInput) return;

    for (var j = 0; j < inputs.length; j++) {
      inputs[j].checked = false;
    }
    matchingInput.checked = true;
  }

  // ─── Init carte ───────────────────────────────────────────────────────────

  function initCard(card) {
    if (card._connecInited) return;
    card._connecInited = true;
    // Le badge variant est géré par .card-variant-badge (collection-badge.js)
  }

  function save(card) {
    if (card._connecSaved) return;
    card._connecSaved = true;
    var img = card.querySelector('.product-card__image--primary');
    if (img) { card._origImgSrc = img.src; card._origImgSrcset = img.srcset || ''; }
    var pl = card.querySelector('price-list');
    if (pl) card._origPrice = pl.innerHTML;
    var saleBadge = card.querySelector('on-sale-badge');
    if (saleBadge) { card._origSaleBadge = saleBadge.textContent; card._origSaleBadgeDisplay = saleBadge.style.display; }
  }

  function updateCard(card, variant) {
    if (!variant) return;

    // 1. Image + anneau swatch
    var inputs = card.querySelectorAll('input[data-variant-id]');
    for (var i = 0; i < inputs.length; i++) { inputs[i].checked = false; }
    for (var i = 0; i < inputs.length; i++) {
      if (String(inputs[i].dataset.variantId) === String(variant.id)) {
        inputs[i].checked = true;
        if (inputs[i].dataset.variantMedia) {
          try {
            var media = JSON.parse(inputs[i].dataset.variantMedia);
            var mediaSrc = (media.preview_image || media).src;
            if (mediaSrc) {
              var img = card.querySelector('.product-card__image--primary');
              if (img) {
                var src = mediaSrc + (mediaSrc.indexOf('?') >= 0 ? '&' : '?') + 'width=800';
                img.src = src;
                img.srcset = src + ' 800w';
              }
            }
          } catch (e) {}
        }
        break;
      }
    }

    // 2. Prix
    var pl = card.querySelector('price-list');
    if (pl) {
      var p = money(variant.price);
      var cmp = (variant.compare_at_price && variant.compare_at_price > variant.price) ? money(variant.compare_at_price) : null;
      pl.innerHTML = cmp
        ? '<sale-price class="text-on-sale"><span class="sr-only">Sale price</span>' + p + '</sale-price>'
          + '<compare-at-price class="text-subdued line-through"><span class="sr-only">Regular price</span>' + cmp + '</compare-at-price>'
        : '<sale-price><span class="sr-only">Regular price</span>' + p + '</sale-price>';
    }

    // 3. Badge Save $X
    var saleBadge = card.querySelector('on-sale-badge');
    if (saleBadge) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        saleBadge.textContent = 'Save ' + money(variant.compare_at_price - variant.price);
        saleBadge.style.display = '';
      } else {
        saleBadge.style.display = 'none';
      }
    }

    // 4. Badge variant — lookup par variant ID
    var cardBadgeMap = {};
    try { cardBadgeMap = JSON.parse(card.dataset.badgeMap || '{}'); } catch(e) {}
    var rawBadge = Object.prototype.hasOwnProperty.call(cardBadgeMap, String(variant.id))
      ? cardBadgeMap[String(variant.id)]
      : '';
    applyCardBadge(card, rawBadge);
  }

  function reset(card) {
    if (!card._connecSaved) return;

    // Restaure image
    var img = card.querySelector('.product-card__image--primary');
    if (img && card._origImgSrc) { img.src = card._origImgSrc; img.srcset = card._origImgSrcset; }

    // Re-synchronise l'anneau sur l'image restaurée
    syncSwatchRingToImage(card);

    // Restaure prix
    var pl = card.querySelector('price-list');
    if (pl && card._origPrice !== undefined) pl.innerHTML = card._origPrice;

    // Restaure badge Save $X
    var saleBadge = card.querySelector('on-sale-badge');
    if (saleBadge && card._origSaleBadge !== undefined) {
      saleBadge.textContent = card._origSaleBadge;
      saleBadge.style.display = card._origSaleBadgeDisplay || '';
    }

    // Restaure le badge du swatch coché (pas defaultBadge qui peut être vide)
    var cardBadgeMap = {};
    try { cardBadgeMap = JSON.parse(card.dataset.badgeMap || '{}'); } catch(e) {}
    applyCardBadge(card, getBadgeForCheckedSwatch(card, cardBadgeMap));
  }

  // ─── Synchro initiale ────────────────────────────────────────────────────

  function syncAllCards() {
    document.querySelectorAll('product-card').forEach(function (card) {
      if (!card._connecRingSynced) {
        card._connecRingSynced = true;
        syncSwatchRingToImage(card);
      }
    });
  }

  // ─── Events ───────────────────────────────────────────────────────────────

  document.addEventListener('mouseover', function (e) {
    var label = e.target.closest('label.color-swatch');
    if (!label) return;
    var card = label.closest('product-card');
    if (!card) return;
    var handle = card.getAttribute('handle');
    if (!handle) return;
    var forId = label.getAttribute('for');
    var input = forId ? document.getElementById(forId) : null;
    var variantId = input ? input.dataset.variantId : null;
    if (!variantId) return;
    initCard(card);
    save(card);
    fetchProduct(handle, function (data) {
      var variant = findVariantById(data, variantId);
      if (!variant) return;
      updateCard(card, variant);
    });
  });

  document.addEventListener('mouseleave', function (e) {
    var card = e.target.closest ? e.target.closest('product-card') : null;
    if (!card) return;
    if (!e.relatedTarget || !card.contains(e.relatedTarget)) reset(card);
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncAllCards);
  } else {
    syncAllCards();
  }

  var obs = new MutationObserver(function () { syncAllCards(); });
  obs.observe(document.body, { childList: true, subtree: true });

})();